import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useStyles } from './styles';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';

function TeamSizeSelectOption({ label, value, checked, onChange, condensed }) {
  const classes = useStyles();

  return (
    <label
      className={clsx(
        classes.option,
        condensed && classes.optionCondensed,
        checked && classes.optionActive,
      )}
    >
      <input type="radio" name="teamSize" value={value} checked={checked} onChange={onChange} />
      <span>{label}</span>
    </label>
  );
}

const Props = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  teamSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  condensed: PropTypes.bool, // for the checkout page
};

export default function TeamSizeSelect({ options, teamSize, onChange, condensed }) {
  const classes = useStyles();
  const { t } = useTranslation('pricing');

  return (
    <Box className={clsx(classes.groupContainer, condensed && classes.groupContainerCondensed)}>
      {options.map((option) => {
        if (option.value === 'more') {
          return (
            <TeamSizeSelectOption
              key={option.id}
              label={t('teams_plan.more_options.title')}
              value={option.value}
              checked={teamSize === option.value}
              onChange={() => onChange(option.value)}
              condensed={condensed}
            />
          );
        }

        return (
          <TeamSizeSelectOption
            key={option.id}
            label={option.value}
            value={option.value}
            checked={teamSize === option.value}
            onChange={() => onChange(option.value)}
            condensed={condensed}
          />
        );
      })}
    </Box>
  );
}

TeamSizeSelect.propTypes = Props;
